const reducer = (state, action) => ({
  ...state,
  error: action.error,
  pending: false,
});

export default reducer;
